import api from '@/services/Api';
import { Product } from '@/models/referentiel/product/Product'
import { ModelSerialNumber } from '@/models/referentiel/product/ModelSerialNumber'

class ProductService {
  async getPaginatedNetworkAndStoreProductList(search, sort, order, page, limit, filters, storeId) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    let encodedStoreId = encodeURIComponent(storeId)

    const url = '/distributor/product/list/' + encodedStoreId +
      '?search=' + encodeURIComponent(search) +
      '&sort=' + sort +
      '&order=' + order +
      '&page=' + page +
      '&limit=' + limit +
      '&filters=' + filters;
    const response = await api.get(url)
    return response.data
  }

  async getProductList(productBoomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const url = '/distributor/product/all-by-product-boomerang-id/'
      + encodedProductBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getProductListBySubCategory(subCategoryBoomerangId) {
    let encodedSubCategoryBoomerangId = encodeURIComponent(subCategoryBoomerangId)
    const url = '/distributor/product/all-by-product-by-sub-category/'
     + encodedSubCategoryBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getProduct(productBoomerangId) {
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const response = await api.get('/distributor/product/'
      + encodedProductBoomerangId)

    let modelSerialNumber = null
    if (response.data.model_serial_number !== null) {
      modelSerialNumber = new ModelSerialNumber(
        response.data.model_serial_number.technical_id,
        response.data.model_serial_number.format,
        response.data.model_serial_number.description,
        response.data.model_serial_number.error_message,
        response.data.model_serial_number.guarantee_exclusion,
        response.data.model_serial_number.type
      )
    }

    return new Product(
      response.data.technical_id,
      response.data.boomerang_id,
      response.data.boomerang_name,
      response.data.length,
      response.data.width,
      response.data.weight,
      response.data.reparable,
      response.data.comment,
      response.data.product_type,
      response.data.picture,
      response.data.serial_number_picture,
      modelSerialNumber
    )
  }

  async getProductDistributorRefList(networkBoomerangId, productBoomerangId) {
    let encodedNetworkBoomerangId = encodeURIComponent(networkBoomerangId)
    let encodedProductBoomerangId = encodeURIComponent(productBoomerangId)

    const url = '/distributor/product/distributor-ref-list/'
      + encodedNetworkBoomerangId + '/' + encodedProductBoomerangId
    const response = await api.get(url)
    return response.data
  }
}

export default new ProductService()
